<template>
  <v-card class="mx-auto flex-grow-1">
    <v-toolbar dense color="red lighten-1">
      <v-toolbar-title class="white--text">Contracheques</v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-if="paychecks"
        v-model="Pesquisar"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-if="paychecks"
      :headers="headers"
      :items="paychecks"
      sort-by="name"
      :search="Pesquisar"
      class="elevation-3"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn text small icon class="mr-2" color="green" @click="downloadPaycheck(item.id)">
          <v-icon medium> mdi-cloud-download </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as api from '@/http'

export default {
  name: 'PayChecks',
  data: function () {
    return {
      Pesquisar: '',
      headers: [
        {
          text: 'Mês',
          value: 'month',
        },
        { text: 'Ano', value: 'year' },
        { text: '', value: 'actions', width: '80' },
      ],
    }
  },
  computed: { ...mapState('employees', ['paychecks']) },
  watch: {},
  methods: {
    ...mapActions('employees', ['ActionDownloadPaycheck']),
    async downloadPaycheck(id) {
      try {
        this.ActionDownloadPaycheck(id)
      } catch (error) {
        console.log(error)
      }
      //   const name = this.paychecks.find((pay) => pay.id === id)

      //   const request = await api.http.post(
      //     'employees/paycheck/download',
      //     { id },
      //     {
      //       responseType: 'arraybuffer',
      //     }
      //   )
      //   var out = new Blob([request.data], { type: 'application/pdf' })
      //   var _global =
      //     typeof window === 'object' && window.window === window
      //       ? window
      //       : typeof self === 'object' && self.self === self
      //       ? self
      //       : typeof global === 'object' && global.global === global
      //       ? global
      //       : this

      //   var force = out.type === 'application/octet-stream'
      //   var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari
      //   var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent)
      //   var isMacOSWebView =
      //     /Macintosh/.test(navigator.userAgent) &&
      //     /AppleWebKit/.test(navigator.userAgent) &&
      //     !/Safari/.test(navigator.userAgent)

      //   if (
      //     (isChromeIOS || (force && isSafari) || isMacOSWebView) &&
      //     typeof FileReader !== 'undefined'
      //   ) {
      //     // Safari doesn't allow downloading of blob URLs
      //     var reader = new FileReader()
      //     reader.onload = function (e) {
      //       window.location.href = reader.result
      //     }
      //     reader.readAsDataURL(out)
      //   } else {
      //     var URL = _global.URL || _global.webkitURL
      //     var url = URL.createObjectURL(out)
      //     location.href = url
      //     setTimeout(function () {
      //       URL.revokeObjectURL(url)
      //     }, 2000)
      //   }
      // },
    },
  },
  created: function () {},
}
</script>
